import {
  actionCreator,
  checkHttpStatus,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  MaintenanceLevelsActionTypes,
  GET_MAINTENANCE_LEVELS_LIST_API,
  POST_MAINTENANCE_LEVELS_API,
  GET_MAINTENANCE_LEVELS_DETAILS_API,
  DELETE_MAINTENANCE_LEVELS_API,
  GET_MASTERDATABYNAME, 
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI, showWarningMessage } from '../../../../actions/utilAction';


export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(MaintenanceLevelsActionTypes.get_master_data.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(MaintenanceLevelsActionTypes.get_master_data.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getMasterData...', error);
      });
  };
};


export const getMaintenanceLevelsList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(MaintenanceLevelsActionTypes.get_maintenanceLevelsList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_MAINTENANCE_LEVELS_LIST_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(MaintenanceLevelsActionTypes.get_maintenanceLevelsList.SUCCESS, response));
        } else {
          dispatch(actionCreator(MaintenanceLevelsActionTypes.get_maintenanceLevelsList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_maintenanceLevelsList ', error);
      });
  };
};

export const saveMaintenanceLevels = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(MaintenanceLevelsActionTypes.post_maintenanceLevels.REQUEST));
    fetch(POST_MAINTENANCE_LEVELS_API, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(MaintenanceLevelsActionTypes.post_maintenanceLevels.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(MaintenanceLevelsActionTypes.post_maintenanceLevels.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_maintenanceLevels', error);
      });
  };
};

export const getMaintenanceLevelsDetails = (CollectionFrequencyID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(MaintenanceLevelsActionTypes.get_maintenanceLevelsDetails.REQUEST));
    fetch(`${GET_MAINTENANCE_LEVELS_DETAILS_API}?maintenanceLevelId=${CollectionFrequencyID}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(MaintenanceLevelsActionTypes.get_maintenanceLevelsDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(MaintenanceLevelsActionTypes.get_maintenanceLevelsDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_maintenanceLevelsDetails ', error);
      });
  };
};

export const deleteMaintenanceLevels = (CollectionFrequencyID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(MaintenanceLevelsActionTypes.delete_maintenanceLevels.REQUEST));
    fetch(`${DELETE_MAINTENANCE_LEVELS_API}?maintenanceLevelId=${CollectionFrequencyID}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200 || response.statusCode === 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(MaintenanceLevelsActionTypes.delete_maintenanceLevels.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(MaintenanceLevelsActionTypes.delete_maintenanceLevels.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(MaintenanceLevelsActionTypes.delete_maintenanceLevels.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_maintenanceLevels', error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/maintenanceLevel/actions/MaintenanceLevelsActions.js